import { render, staticRenderFns } from "./ClipVideoSkeleton.vue?vue&type=template&id=54f80794&"
import script from "./ClipVideoSkeleton.vue?vue&type=script&lang=js&"
export * from "./ClipVideoSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ClipVideoSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports